import {Button, Div, ImageView, Label} from 'components';
import {Ecolors, Icons} from 'constant';
import React from 'react';
import {navigate} from 'services';

const RegulationCom = () => {
  return (
    <Div
      marginTop={10}
      alignItems="center"
      flexDirection="row"
      justifyContent="space-between">
      <Div alignItems="center" justifyContent="center">
        <Button
          onPress={() => {
            navigate('RegulationModal');
          }}
          width={200}
          marginBottom={50}
          paddingHorizontal={14}
          alignItems="center"
          justifyContent="center"
          paddingVertical={6}
          borderRadius={20}
          backgroundColor={Ecolors.textColor}>
          <Label
            size={14}
            color={
              Ecolors.whiteColor
            }>{`eventreward.xemquydinhchuongtrinh`}</Label>
        </Button>
      </Div>
      <ImageView
        marginLeft={-28}
        source={Icons.regulation}
        width={170}
        height={113}
        resizeMode="contain"
      />
    </Div>
  );
};

export default React.memo(RegulationCom);
